"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DialogProps_1 = require("./DialogProps");
var styles = require("./Dialog.css");
require("./Dialog.tablet.css");
var Modal_1 = require("../Modal/Modal");
var ButtonProps_1 = require("../Button/ButtonProps");
var Button_1 = require("../Button/Button");
var icons = require("./../../../styles/att-icons.css");
var utils_1 = require("../../../utils/utils");
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            actions: [],
            message: '',
            onCancel: _this.hide,
            showClose: true,
            showModal: false,
            title: '',
            type: DialogProps_1.DialogTypes.CONFIRMATION,
        };
        return _this;
    }
    Dialog.Action = function (label, callback, type) {
        return {
            callback: callback,
            label: label,
            type: type,
        };
    };
    Dialog.OKAction = function (callback, type) {
        return Dialog.Action('OK', callback, type || ButtonProps_1.ButtonType.PRIMARY);
    };
    Dialog.CancelAction = function (callback, type) {
        return Dialog.Action('Cancel', callback, type || ButtonProps_1.ButtonType.GHOST);
    };
    Dialog.prototype.show = function (options) {
        var _this = this;
        var actions = options.actions, onCancel = options.onCancel, resOptions = __rest(options, ["actions", "onCancel"]);
        this.setState(__assign(__assign({}, resOptions), { actions: this.mapActions(actions), onCancel: function () {
                _this.hide();
                onCancel();
            }, showModal: true }));
    };
    Dialog.prototype.mapActions = function (actions) {
        var _this = this;
        return actions.map(function (action) {
            return {
                data: {
                    text: action.label,
                },
                events: {
                    onClick: function () {
                        _this.hide();
                        action.callback();
                    },
                },
                options: {
                    type: action.type,
                },
            };
        });
    };
    Dialog.prototype.hide = function () {
        if (!this.state.showModal) {
            return;
        }
        this.setState({ showModal: false });
    };
    Dialog.prototype.render = function () {
        if (!this.state.showModal) {
            return null;
        }
        var _a = this, _b = this.state.type + "Title", generateTitle = _a[_b];
        return (React.createElement(Modal_1.default, __assign({ testId: utils_1.default(this.props.testId, 'Modal') }, this.getModalProps()),
            generateTitle.apply(this),
            React.createElement("div", { id: "dialogDesc", className: styles.body }, this.state.message),
            React.createElement("div", { className: [styles.footer, this.getFooterPosition()].join(' ') }, this.getActions())));
    };
    Dialog.prototype.getModalProps = function () {
        return {
            events: {
                onClose: this.state.onCancel,
            },
            options: {
                center: true,
                show: this.state.showModal,
                showClose: this.state.showClose,
            },
        };
    };
    Dialog.prototype.confirmationTitle = function () {
        return (React.createElement("div", { id: "dialogTitle", className: styles.header }, this.state.title));
    };
    Dialog.prototype.errorTitle = function () {
        return (React.createElement("div", { className: [styles.header, styles.errorTitle].join(' ') },
            React.createElement("i", { className: [icons.attIcon, icons.attIconAlert, styles.errorIcon].join(' '), role: "text", "aria-label": this.state.alertAccessibility || 'Alert' }),
            React.createElement("span", { id: "dialogTitle" }, this.state.title)));
    };
    Dialog.prototype.getFooterPosition = function () {
        return this.state.actions.length > 1 ? styles.spaceBetween : styles.center;
    };
    Dialog.prototype.getActions = function () {
        var _this = this;
        return this.state.actions.map(function (action, index) {
            return React.createElement(Button_1.default, __assign({ testId: utils_1.default(_this.props.testId, 'Button'), key: index }, action));
        });
    };
    return Dialog;
}(React.Component));
exports.default = Dialog;
//# sourceMappingURL=Dialog.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Dialog/Dialog.js
// module id = 519
// module chunks = 8